<template>
  <div
    id="calendar-sheet__links"
    class="ce-gallery flex justify-center mt-[35px] overflow-visible"
  >
    <!-- Links to videos -->
    <router-link
      v-for="video in routedDay.videos"
      :key="video.slug"
      :to="{
        name: 'CalendarSheetVideoPlayer',
        params: {
          ...$route.params,
          videoSlug: video.slug,
        },
      }"
      class="basis-[130px] text-center"
    >
      <section
        class="calendar-sheet__link--video flex flex-col justify-center m-[6px] text-center"
      >
        {{ video.title }}
      </section>
    </router-link>

    <!-- Links -->
    <a
      v-for="link in routedDay.calendarSheetLinks"
      :key="link"
      :href="link.url"
      target="_blank"
      :class="[{ 'no-lightbox': link.type !== 'lightbox_image' }]"
      class="basis-[130px] text-center mx-3"
    >
      <section
        :class="[`calendar-sheet__link--${link.type}`]"
        class="flex flex-col justify-center m-[6px] text-center"
      >
        {{ link.label }}
      </section>
    </a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

import lightboxInitialize from "../../../lightbox-initialize";
import lightboxDestroy from "../../../lightbox-destroy";

export default {
  name: "CalendarSheetLinks",
  computed: {
    ...mapGetters(["routedDay"]),
  },
  watch: {
    routedDay(newDay) {
      if (!newDay) {
        return;
      }
      this.$nextTick(() => {
        lightboxDestroy();
        lightboxInitialize();
      });
    },
  },
  mounted() {
    lightboxInitialize();
  },
  beforeUnmount() {
    lightboxDestroy();
  },
};
</script>
